module.exports = __webpack_public_path__ + "static/media/help-disk-join.dd23c0d4.svg";